import React, { useState, useContext } from 'react';
import { Trans } from '@lingui/react';
import TextWithIcon from './../components/TextWithIcon';
import ConfirmDeletePlaylistModal from './../organisms/modals/ConfirmDeletePlaylistModal';
import { UserContext } from '../lib/contexts/UserProvider';

const ButtonDeletePlaylist = props => {
  const [currentUser, { loading, error }] = useContext(UserContext);
  const [
    confirmDeletePlaylistModalOpen,
    setConfirmDeletePlaylistModalOpen,
  ] = useState();

  if (error) return null;

  const DynamicComponent = props.tag;
  if (loading) {
    return (
      <DynamicComponent disabled={loading}>
        <Trans id="metadata.please_wait" message={`Please wait...`} />
      </DynamicComponent>
    );
  }

  if (currentUser?.id !== props.playlist.ownerId) {
    return null;
  }

  if (currentUser?.id) {
    return (
      <React.Fragment>
        <DynamicComponent
          onClick={() => {
            setConfirmDeletePlaylistModalOpen(true);
          }}
        >
          <TextWithIcon icon="ygb-icon-trash" iconSize="15px">
            <Trans id="metadata.delete_playlist" message="Delete Playlist" />
          </TextWithIcon>
        </DynamicComponent>
        <ConfirmDeletePlaylistModal
          open={confirmDeletePlaylistModalOpen}
          handleClose={() => {
            setConfirmDeletePlaylistModalOpen(false);
          }}
          playlistTitle={props.playlist.title}
          playlistVideoCount={props.playlist.videoCount}
          playlistId={props.playlist.id}
        />
      </React.Fragment>
    );
  }

  return null;
};

export default ButtonDeletePlaylist;
